import { j as o } from "./index.es33.js";
import { t as e } from "./index.es106.js";
import { Icon as t } from "./index.es7.js";
import "./index.es13.js";
import { TooltipShorten as i } from "./index.es14.js";
import "./index.es15.js";
import r from "./index.es577.js";
var c = function c() {
  return o.jsxs("div", {
    className: r.addVariableHeader,
    children: [o.jsx(t, {
      size: 16,
      icon: t.icons.system.s.utilities.add
    }), o.jsx(i, {
      title: e("component_component_popupMenu_addCustomVariableLabel")
    })]
  });
};
export { c as VariableHeader };